export type ContentType = "movie" | "tv" | "variety";

export type MediaItem = {
  id: string;
  title: string;
  enTitle: string;
  type: ContentType;
  genres: string[];
  region: string;
  year: number;
  rating: number;
  heat: number;
  episodes: number;
  duration: string;
  director: string;
  cast: string[];
  updatedAt: string;
  status: string;
  cover: string;
  backdrop: string;
  synopsis: string;
  tags: string[];
  featured?: boolean;
};

export const mediaList: MediaItem[] = [
  {
    id: "m-001",
    title: "深海回声",
    enTitle: "Echoes of the Deep",
    type: "movie",
    genres: ["剧情", "悬疑"],
    region: "欧美",
    year: 2025,
    rating: 9.1,
    heat: 9860,
    episodes: 1,
    duration: "132分钟",
    director: "埃利亚斯·沃克",
    cast: ["玛格丽特·凯恩", "托马斯·里德", "张佑宁"],
    updatedAt: "2025-10-14",
    status: "高清蓝光",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20lone%20diver%20silhouette%20descending%20into%20deep%20dark%20ocean%20water%20with%20a%20single%20shaft%20of%20light%2C%20moody%20deep%20navy%20tones%2C%20high%20contrast%20film%20noir%20style%2C%20minimal%20typography%20space%20at%20bottom&width=600&height=900&seq=97v-cover-001&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20underwater%20scene%20with%20glowing%20blue%20light%20rays%20piercing%20deep%20ocean%20darkness%2C%20tiny%20human%20silhouette%2C%20epic%20atmospheric%20film%20still%2C%20rich%20navy%20and%20teal%20tones&width=1600&height=900&seq=97v-back-001&orientation=landscape",
    synopsis:
      "一支海洋科考队在太平洋马里亚纳海沟边缘接收到一段来自深海的规律声波，声波的节奏竟与二十年前失踪的科考船最后通讯记录完全一致。队长林知微带着仅存的四名队员下潜，在四千米的黑暗中，他们发现了人类从未记录的巨型结构，也发现了彼此不愿提起的过去。",
    tags: ["深海", "科幻悬疑", "海上冒险", "高口碑"],
    featured: true,
  },
  {
    id: "m-002",
    title: "雾城追光",
    enTitle: "Light Chaser",
    type: "movie",
    genres: ["犯罪", "动作"],
    region: "大陆",
    year: 2024,
    rating: 8.6,
    heat: 9120,
    episodes: 1,
    duration: "118分钟",
    director: "陈戌",
    cast: ["周砚", "李曼青", "何峻"],
    updatedAt: "2025-10-11",
    status: "超清",
    cover: "https://readdy.ai/api/search-image?query=Neo%20noir%20Chinese%20crime%20film%20poster%2C%20a%20detective%20in%20trench%20coat%20standing%20in%20thick%20fog%20on%20a%20wet%20city%20street%20with%20orange%20neon%20reflections%2C%20dramatic%20backlight%2C%20dark%20grey%20and%20amber%20palette&width=600&height=900&seq=97v-cover-002&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Moody%20foggy%20modern%20city%20street%20at%20night%20with%20orange%20neon%20signs%20reflected%20on%20wet%20asphalt%2C%20cinematic%20wide%20shot%2C%20dark%20grey%20and%20amber%20color%20grading&width=1600&height=900&seq=97v-back-002&orientation=landscape",
    synopsis:
      "雾都连续三起雨夜案件将刑警沈砚推上舆论风口。所有线索都指向十年前一桩被定性为意外的旧案，而当年主办此案的人正是他的父亲。在能见度不足十米的城市里，他必须找到那个一直在暗处替他点灯的人。",
    tags: ["悬疑追凶", "雨夜美学", "警匪", "强叙事"],
    featured: true,
  },
  {
    id: "m-003",
    title: "山海画卷",
    enTitle: "Scroll of Mountains and Seas",
    type: "movie",
    genres: ["奇幻", "动画"],
    region: "大陆",
    year: 2025,
    rating: 8.9,
    heat: 8730,
    episodes: 1,
    duration: "104分钟",
    director: "苏白羽",
    cast: ["许尽欢", "顾清和", "陆遥"],
    updatedAt: "2025-10-08",
    status: "高清",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20mythical%20animated%20film%20poster%2C%20a%20young%20painter%20riding%20a%20giant%20ink%20painted%20mythical%20beast%20through%20clouds%2C%20elegant%20ink%20wash%20art%20with%20deep%20navy%20and%20gold%20accents%2C%20epic%20vertical%20composition&width=600&height=900&seq=97v-cover-003&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Sprawling%20Chinese%20ink%20painting%20landscape%20with%20floating%20mountains%2C%20golden%20clouds%20and%20a%20tiny%20bridge%20between%20peaks%2C%20cinematic%20animation%20background%2C%20deep%20navy%20blue%20with%20warm%20gold%20light&width=1600&height=900&seq=97v-back-003&orientation=landscape",
    synopsis:
      "临摹了十年古画的学徒阿禾意外被卷入自己笔下未完成的山海长卷。画卷中的神兽正被一种吞噬墨色的虚无侵蚀，她必须在画魂散尽之前，用自己从未被承认的笔触，补上那个空缺了三百年的结局。",
    tags: ["国风动画", "神话", "成长", "视觉盛宴"],
    featured: true,
  },
  {
    id: "m-004",
    title: "第二十三层",
    enTitle: "Floor Twenty Three",
    type: "movie",
    genres: ["悬疑", "科幻"],
    region: "日韩",
    year: 2024,
    rating: 8.3,
    heat: 7640,
    episodes: 1,
    duration: "121分钟",
    director: "中岛凉介",
    cast: ["泽木真一", "石川由纪", "朴泰勋"],
    updatedAt: "2025-10-05",
    status: "超清",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20psychological%20thriller%20poster%20of%20a%20man%20standing%20in%20an%20empty%20endless%20hotel%20corridor%20with%20repeating%20doors%2C%20cold%20fluorescent%20lighting%2C%20eerie%20minimal%20composition%2C%20desaturated%20teal%20grey%20palette&width=600&height=900&seq=97v-cover-004&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Symmetrical%20endless%20hotel%20corridor%20vanishing%20into%20darkness%2C%20cold%20fluorescent%20lamps%2C%20eerie%20liminal%20space%2C%20desaturated%20teal%20and%20grey%20cinematic%20still&width=1600&height=900&seq=97v-back-004&orientation=landscape",
    synopsis:
      "电梯按钮上从不存在第二十三层。程序员崔敏在连续加班第十一天后，误按了那个多出来的按钮，醒来时发现整栋大楼只剩下他一个人，而所有时钟都停在同一分钟。每打开一扇门，他就回到自己人生中某个无法改写的瞬间。",
    tags: ["烧脑", "时间循环", "密闭空间", "日韩佳片"],
  },
  {
    id: "m-005",
    title: "长夏未央",
    enTitle: "Endless Summer",
    type: "movie",
    genres: ["爱情", "剧情"],
    region: "大陆",
    year: 2023,
    rating: 8.0,
    heat: 6820,
    episodes: 1,
    duration: "109分钟",
    director: "沈栖",
    cast: ["温以宁", "宋清野", "陈之遥"],
    updatedAt: "2025-09-28",
    status: "高清",
    cover: "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20romance%20film%20poster%20of%20two%20young%20people%20on%20a%20seaside%20pier%20at%20golden%20sunset%2C%20soft%20film%20grain%2C%20gentle%20pastel%20amber%20and%20cream%20tones%2C%20breezy%20summer%20mood&width=600&height=900&seq=97v-cover-005&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Quiet%20seaside%20town%20pier%20during%20golden%20hour%20sunset%20with%20gentle%20waves%2C%20warm%20amber%20light%20and%20soft%20haze%2C%20nostalgic%20cinematic%20summer%20atmosphere&width=1600&height=900&seq=97v-back-005&orientation=landscape",
    synopsis:
      "小镇灯塔管理员夏未央在二十年后的夏天收到一封没有寄件人的信，信里只有一张褪色的胶片和一句“我在长夏尽头等你”。她带着胶片回到那座已经被拆掉一半的老电影院，重新走过那个她以为早已忘记的暑假。",
    tags: ["青春爱情", "治愈", "海边", "怀旧"],
  },
  {
    id: "m-006",
    title: "钢铁边境",
    enTitle: "Iron Frontier",
    type: "movie",
    genres: ["动作", "战争"],
    region: "欧美",
    year: 2024,
    rating: 7.8,
    heat: 7210,
    episodes: 1,
    duration: "126分钟",
    director: "卢卡斯·莫兰",
    cast: ["德里克·霍尔", "安娜·费舍尔", "米格尔·桑托斯"],
    updatedAt: "2025-09-24",
    status: "超清",
    cover: "https://readdy.ai/api/search-image?query=Rugged%20war%20action%20movie%20poster%20with%20a%20soldier%20silhouette%20against%20a%20smoky%20orange%20sky%20and%20wrecked%20armored%20vehicle%2C%20gritty%20industrial%20tone%2C%20strong%20backlight%2C%20dark%20steel%20and%20amber%20palette&width=600&height=900&seq=97v-cover-006&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Desolate%20industrial%20borderland%20at%20dusk%20with%20smoke%2C%20rusty%20containers%20and%20searchlights%2C%20gritty%20war%20cinematic%20wide%20shot%2C%20dark%20steel%20blue%20and%20amber&width=1600&height=900&seq=97v-back-006&orientation=landscape",
    synopsis:
      "边境线上最后一支维和车队的燃料只剩三天。机械工程师伊莎被临时指派维修一台早已报废的装甲车，而这台车的黑匣子里，装着足以改变整场冲突走向的记录。",
    tags: ["硬核动作", "战争群像", "爆破场面"],
  },
  {
    id: "m-007",
    title: "喜剧演员的葬礼",
    enTitle: "A Comedian's Funeral",
    type: "movie",
    genres: ["喜剧", "剧情"],
    region: "大陆",
    year: 2025,
    rating: 8.5,
    heat: 6980,
    episodes: 1,
    duration: "112分钟",
    director: "老周",
    cast: ["马三川", "范可心", "刘敢"],
    updatedAt: "2025-10-02",
    status: "高清",
    cover: "https://readdy.ai/api/search-image?query=Tragicomic%20Chinese%20film%20poster%20of%20a%20middle-aged%20comedian%20in%20a%20bright%20suit%20holding%20a%20microphone%20under%20a%20single%20spotlight%20on%20an%20empty%20stage%2C%20dramatic%20warm%20orange%20light%20against%20deep%20navy%20darkness&width=600&height=900&seq=97v-cover-007&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Empty%20old%20theatre%20stage%20with%20red%20velvet%20curtains%20and%20a%20single%20spotlight%20beam%2C%20dust%20in%20the%20air%2C%20warm%20amber%20and%20deep%20brown%20cinematic%20tone&width=1600&height=900&seq=97v-back-007&orientation=landscape",
    synopsis:
      "三流喜剧演员马三川在自己的“生前告别演出”上被宣布死亡。消息传开后，他忽然成了全城最红的笑星。为了不让母亲看到讣告，他不得不一边假装活着，一边学着怎么真正活一次。",
    tags: ["黑色幽默", "小人物", "温情", "年度惊喜"],
  },
  {
    id: "m-008",
    title: "极地信标",
    enTitle: "Polar Beacon",
    type: "movie",
    genres: ["冒险", "剧情"],
    region: "欧美",
    year: 2023,
    rating: 8.1,
    heat: 5320,
    episodes: 1,
    duration: "115分钟",
    director: "英格丽·诺德",
    cast: ["汉娜·奥斯陆", "埃里克·林", "米娅·科尔"],
    updatedAt: "2025-09-16",
    status: "高清",
    cover: "https://readdy.ai/api/search-image?query=Arctic%20adventure%20film%20poster%20with%20a%20lone%20radio%20operator%20in%20a%20small%20snowbound%20station%2C%20aurora%20green%20lights%20over%20white%20tundra%2C%20vast%20minimal%20composition%2C%20cool%20blue%20with%20warm%20window%20glow&width=600&height=900&seq=97v-cover-008&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Vast%20arctic%20tundra%20under%20green%20aurora%20night%20sky%20with%20a%20tiny%20lit%20research%20station%2C%20snow%20plains%2C%20cinematic%20wide%20shot%2C%20icy%20blue%20and%20emerald%20tones&width=1600&height=900&seq=97v-back-008&orientation=landscape",
    synopsis:
      "极夜第 87 天，气象站值班员接到一段来自三十年前的信标广播。她只有一次机会，在暴风雪封死最后一条航线之前，把回复发出去。",
    tags: ["极地生存", "孤独", "女性主角"],
  },
  {
    id: "m-009",
    title: "影宅谜局",
    enTitle: "The Screening Room",
    type: "movie",
    genres: ["悬疑", "剧情"],
    region: "日韩",
    year: 2025,
    rating: 8.7,
    heat: 8010,
    episodes: 1,
    duration: "107分钟",
    director: "松田和臣",
    cast: ["藤井圭", "林清夏", "金度完"],
    updatedAt: "2025-10-12",
    status: "超清",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20mystery%20film%20poster%20featuring%20an%20old%20private%20cinema%20projector%20casting%20a%20huge%20shadow%20onto%20the%20wall%2C%20dusty%20amber%20light%20beam%2C%20deep%20shadow%20contrast%2C%20elegant%20poster%20composition&width=600&height=900&seq=97v-cover-009&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Vintage%20private%20screening%20room%20with%20red%20seats%20and%20a%20glowing%20projector%20beam%20cutting%20through%20dust%2C%20mysterious%20warm%20amber%20and%20deep%20maroon%20cinematic%20lighting&width=1600&height=900&seq=97v-back-009&orientation=landscape",
    synopsis:
      "电影修复师收到一卷没有编号的胶片，画面里拍下的正是他将要在三天后经历的每一件事。当影片最后一帧出现他自己的死亡现场，他决定改变放映的顺序。",
    tags: ["悬疑推理", "电影哲学", "反转结尾"],
  },
  {
    id: "m-010",
    title: "星轨之外",
    enTitle: "Beyond the Orbit",
    type: "movie",
    genres: ["科幻", "剧情"],
    region: "大陆",
    year: 2024,
    rating: 8.4,
    heat: 7350,
    episodes: 1,
    duration: "133分钟",
    director: "程远舟",
    cast: ["纪云深", "叶繁", "谭星野"],
    updatedAt: "2025-09-30",
    status: "高清蓝光",
    cover: "https://readdy.ai/api/search-image?query=Science%20fiction%20film%20poster%20with%20an%20astronaut%20floating%20in%20front%20of%20a%20giant%20planets%20glowing%20rim%2C%20deep%20space%20darkness%2C%20orange%20sun%20flare%20accent%2C%20epic%20vertical%20layout&width=600&height=900&seq=97v-cover-010&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Epic%20space%20scene%20with%20a%20space%20station%20silhouette%20against%20a%20giant%20orange-lit%20planet%20horizon%2C%20starfield%2C%20cinematic%20hard%20sci-fi%20look%2C%20deep%20navy%20and%20amber&width=1600&height=900&seq=97v-back-010&orientation=landscape",
    synopsis:
      "天宫十七号在返航途中与地面失去联系，唯一幸存的女航天员必须独自完成一次没有预案的变轨。而在七千公里外的地面上，她的女儿正在用一台老式无线电，一遍遍念着母亲的呼号。",
    tags: ["硬科幻", "航天", "亲情", "大场面"],
  },
  {
    id: "m-011",
    title: "街角理发店",
    enTitle: "The Corner Barber",
    type: "movie",
    genres: ["剧情", "治愈"],
    region: "大陆",
    year: 2022,
    rating: 8.2,
    heat: 4210,
    episodes: 1,
    duration: "98分钟",
    director: "徐慢",
    cast: ["老范", "李小满", "赵阿姨"],
    updatedAt: "2025-09-08",
    status: "高清",
    cover: "https://readdy.ai/api/search-image?query=Warm%20slice%20of%20life%20film%20poster%20of%20a%20small%20neighborhood%20barbershop%20with%20a%20vintage%20barber%20chair%20and%20warm%20afternoon%20sunlight%20through%20the%20window%2C%20soft%20amber%20and%20cream%20color%20palette%2C%20minimal%20design&width=600&height=900&seq=97v-cover-011&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Cozy%20old%20neighborhood%20street%20with%20a%20small%20barbershop%2C%20afternoon%20golden%20light%2C%20hanging%20laundry%20and%20bicycles%2C%20warm%20nostalgic%20cinematic%20photography&width=1600&height=900&seq=97v-back-011&orientation=landscape",
    synopsis:
      "老城改造前最后三十天，开了四十三年的街角理发店迎来一批又一批来“最后剪一次”的老客人。每个人坐下来，都想顺便把一段没说完的故事剪短一点。",
    tags: ["生活流", "邻里", "温情", "高评分"],
  },
  {
    id: "m-012",
    title: "沙丘来信",
    enTitle: "Letters from the Dunes",
    type: "movie",
    genres: ["爱情", "冒险"],
    region: "欧美",
    year: 2023,
    rating: 7.9,
    heat: 3980,
    episodes: 1,
    duration: "119分钟",
    director: "阿米尔·哈桑",
    cast: ["莱拉·纳西尔", "西奥·布朗", "法蒂玛·阿德"],
    updatedAt: "2025-08-29",
    status: "高清",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20desert%20adventure%20film%20poster%20with%20two%20travelers%20walking%20across%20golden%20sand%20dunes%20at%20sunset%2C%20long%20shadows%2C%20warm%20amber%20and%20terracotta%20tones%2C%20minimal%20elegant%20composition&width=600&height=900&seq=97v-cover-012&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Endless%20golden%20sand%20dunes%20at%20sunset%20with%20a%20caravan%20silhouette%2C%20warm%20terracotta%20light%2C%20cinematic%20desert%20landscape%20wide%20shot&width=1600&height=900&seq=97v-back-012&orientation=landscape",
    synopsis:
      "一封写错地址的信，在沙漠邮路上走了六年。收信人早已搬离，而送信的邮差决定亲自把这段跨越六年的心意送到终点。",
    tags: ["沙漠公路", "慢节奏", "书信", "异域风光"],
  },
  {
    id: "t-001",
    title: "长夜将明",
    enTitle: "Before the Dawn",
    type: "tv",
    genres: ["悬疑", "犯罪"],
    region: "大陆",
    year: 2025,
    rating: 9.3,
    heat: 12400,
    episodes: 24,
    duration: "45分钟/集",
    director: "梁远",
    cast: ["傅青云", "许南音", "郑宥"],
    updatedAt: "2025-10-16",
    status: "更新至24集",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20series%20poster%20with%20a%20police%20detective%20standing%20under%20a%20single%20street%20lamp%20in%20rain%2C%20deep%20navy%20night%20with%20orange%20lamp%20glow%2C%20tense%20atmospheric%20composition&width=600&height=900&seq=97v-cover-013&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Rainy%20night%20city%20overpass%20with%20orange%20street%20lamps%20and%20long%20reflections%2C%20lonely%20figure%20with%20umbrella%2C%20cinematic%20crime%20drama%20still%2C%20deep%20navy%20tones&width=1600&height=900&seq=97v-back-013&orientation=landscape",
    synopsis:
      "滨海市连续发生的失踪案指向一个消失了十五年的犯罪网络。刑警队长江牧与法医顾问南音在旧档库里找到一批被标注“结案”的卷宗，才发现当年那个被全城称颂的英雄，可能正是这一切的起点。",
    tags: ["刑侦", "硬核推理", "群像", "年度口碑"],
    featured: true,
  },
  {
    id: "t-002",
    title: "潮汐之城",
    enTitle: "Tide City",
    type: "tv",
    genres: ["都市", "剧情"],
    region: "大陆",
    year: 2024,
    rating: 8.8,
    heat: 10300,
    episodes: 32,
    duration: "42分钟/集",
    director: "白露",
    cast: ["沈聿", "林夏至", "高唱"],
    updatedAt: "2025-10-15",
    status: "全32集",
    cover: "https://readdy.ai/api/search-image?query=Modern%20urban%20Chinese%20drama%20poster%20with%20a%20young%20woman%20looking%20out%20over%20a%20harbor%20city%20skyline%20at%20dusk%2C%20warm%20peach%20and%20deep%20navy%20gradient%2C%20sophisticated%20editorial%20style&width=600&height=900&seq=97v-cover-014&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Harbor%20city%20skyline%20at%20dusk%20with%20cargo%20ships%20and%20warm%20window%20lights%2C%20calm%20water%20reflections%2C%20cinematic%20urban%20drama%20wide%20shot%2C%20peach%20and%20navy%20tones&width=1600&height=900&seq=97v-back-014&orientation=landscape",
    synopsis:
      "一座靠海运起家的城市，正在经历整个港口的重组。从码头调度员到海关关员，从老船东到新兴科技公司，三代人的去留与选择，在潮水涨落之间一次次被重新定义。",
    tags: ["都市群像", "职场", "时代变迁", "口碑剧"],
    featured: true,
  },
  {
    id: "t-003",
    title: "第九封信",
    enTitle: "The Ninth Letter",
    type: "tv",
    genres: ["悬疑", "爱情"],
    region: "日韩",
    year: 2025,
    rating: 8.9,
    heat: 9600,
    episodes: 16,
    duration: "60分钟/集",
    director: "尹书真",
    cast: ["李贤宇", "韩素璃", "崔元"],
    updatedAt: "2025-10-14",
    status: "更新至16集",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romantic%20mystery%20drama%20poster%20with%20a%20woman%20holding%20old%20letters%20in%20a%20library%20lit%20by%20warm%20lamps%2C%20rain%20on%20the%20window%2C%20muted%20amber%20and%20dusty%20blue%20tones&width=600&height=900&seq=97v-cover-015&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Old%20library%20interior%20at%20night%20with%20rain%20outside%20tall%20windows%2C%20warm%20desk%20lamp%20and%20stacked%20handwritten%20letters%2C%20soft%20amber%20and%20dusty%20blue%20cinematic%20lighting&width=1600&height=900&seq=97v-back-015&orientation=landscape",
    synopsis:
      "图书管理员收到九封没有署名的手写信，每一封都精准描述了她在某一天的心情。当她试图找出写信人时，寄信地址却指向一栋二十年前就已被拆毁的旧公寓。",
    tags: ["双向暗恋", "悬疑爱情", "书信", "韩剧质感"],
  },
  {
    id: "t-004",
    title: "山海食记",
    enTitle: "Mountains & Sea Kitchen",
    type: "tv",
    genres: ["剧情", "治愈"],
    region: "大陆",
    year: 2024,
    rating: 8.6,
    heat: 8100,
    episodes: 20,
    duration: "38分钟/集",
    director: "陈亦可",
    cast: ["白昀", "阿木", "罗晓"],
    updatedAt: "2025-10-10",
    status: "全20集",
    cover: "https://readdy.ai/api/search-image?query=Warm%20Chinese%20food%20drama%20poster%20of%20a%20small%20mountain%20village%20kitchen%20with%20steaming%20dishes%20and%20hanging%20chili%2C%20golden%20afternoon%20light%2C%20rustic%20warm%20amber%20palette%2C%20inviting%20editorial%20composition&width=600&height=900&seq=97v-cover-016&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Rustic%20mountain%20village%20courtyard%20kitchen%20with%20steaming%20pots%20and%20firewood%2C%20golden%20sunlight%20through%20leaves%2C%20warm%20cinematic%20food%20documentary%20look&width=1600&height=900&seq=97v-back-016&orientation=landscape",
    synopsis:
      "厨师范白昀继承了一家开在山海交界处的旧式食堂。菜单只有一页，但每一道菜都对应着一位客人的心事。她决定按季节重写这份菜单，也顺便重新整理自己的人生。",
    tags: ["美食", "治愈系", "乡村", "慢生活"],
  },
  {
    id: "t-005",
    title: "云端之上",
    enTitle: "Above the Clouds",
    type: "tv",
    genres: ["剧情", "职场"],
    region: "大陆",
    year: 2023,
    rating: 8.1,
    heat: 6420,
    episodes: 28,
    duration: "44分钟/集",
    director: "韩硕",
    cast: ["程亦", "纪小满", "樊川"],
    updatedAt: "2025-09-26",
    status: "全28集",
    cover: "https://readdy.ai/api/search-image?query=Aviation%20drama%20poster%20with%20a%20female%20pilot%20silhouette%20in%20a%20cockpit%20at%20dawn%2C%20cloud%20sea%20outside%20the%20window%2C%20calm%20blue%20grey%20and%20soft%20orange%20sunrise%20tones%2C%20clean%20modern%20composition&width=600&height=900&seq=97v-cover-017&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Endless%20sea%20of%20clouds%20at%20sunrise%20seen%20from%20above%2C%20soft%20orange%20horizon%20and%20cool%20blue%20shadows%2C%20cinematic%20aerial%20view&width=1600&height=900&seq=97v-back-017&orientation=landscape",
    synopsis:
      "航空公司最年轻的机长候选人，在一次例行的复训中被判定为“不具备心理稳定性”。为了重新飞上天，她必须面对那段自己从未对任何人说过的备降经历。",
    tags: ["航空职场", "女性成长", "励志"],
  },
  {
    id: "t-006",
    title: "银河邮局",
    enTitle: "Galaxy Post Office",
    type: "tv",
    genres: ["科幻", "奇幻"],
    region: "日韩",
    year: 2024,
    rating: 8.7,
    heat: 7900,
    episodes: 12,
    duration: "52分钟/集",
    director: "小林遥",
    cast: ["石原理央", "加藤陆", "千夏"],
    updatedAt: "2025-10-07",
    status: "全12集",
    cover: "https://readdy.ai/api/search-image?query=Whimsical%20sci-fi%20drama%20poster%20of%20a%20small%20floating%20post%20office%20island%20in%20space%2C%20glowing%20mail%20envelopes%20drifting%2C%20starry%20deep%20navy%20background%20with%20warm%20amber%20lantern%20light&width=600&height=900&seq=97v-cover-018&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Surreal%20space%20station%20post%20office%20with%20glowing%20lanterns%20and%20floating%20paper%20letters%20against%20a%20starry%20nebula%2C%20dreamy%20cinematic%20fantasy%20look%2C%20deep%20navy%20and%20warm%20gold&width=1600&height=900&seq=97v-back-018&orientation=landscape",
    synopsis:
      "宇宙邮局的最后一任局长，负责投递那些寄给“已经不存在的人”的信。每投出一封，她就会失去一段关于自己的记忆。而最后一封信的收件人，写的是她自己的名字。",
    tags: ["奇幻治愈", "信件", "记忆", "脑洞设定"],
  },
  {
    id: "t-007",
    title: "热血少年团",
    enTitle: "The Young Squad",
    type: "tv",
    genres: ["青春", "励志"],
    region: "大陆",
    year: 2025,
    rating: 7.6,
    heat: 6700,
    episodes: 30,
    duration: "40分钟/集",
    director: "赵启帆",
    cast: ["顾一航", "沈楚", "夏天予"],
    updatedAt: "2025-10-13",
    status: "更新至28集",
    cover: "https://readdy.ai/api/search-image?query=Energetic%20youth%20sports%20drama%20poster%20with%20a%20teenage%20basketball%20team%20in%20orange%20jerseys%20celebrating%20on%20an%20outdoor%20court%20at%20golden%20hour%2C%20dynamic%20composition&width=600&height=900&seq=97v-cover-019&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Outdoor%20basketball%20court%20at%20golden%20hour%20with%20teenagers%20playing%2C%20long%20shadows%20and%20warm%20orange%20sunlight%2C%20energetic%20cinematic%20youth%20drama%20shot&width=1600&height=900&seq=97v-back-019&orientation=landscape",
    synopsis:
      "一支连续三年小组赛出局的校队，迎来了一个不会投篮的新教练。这个夏天，他们要赢的不是冠军，而是重新相信彼此。",
    tags: ["青春热血", "校园", "群像成长"],
  },
  {
    id: "t-008",
    title: "皇城夜行",
    enTitle: "Night Watch of the Capital",
    type: "tv",
    genres: ["古装", "悬疑"],
    region: "大陆",
    year: 2023,
    rating: 8.4,
    heat: 8400,
    episodes: 40,
    duration: "46分钟/集",
    director: "萧轶",
    cast: ["裴峻", "李昭宁", "谢无咎"],
    updatedAt: "2025-09-20",
    status: "全40集",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20drama%20poster%20with%20a%20night%20watchman%20holding%20a%20lantern%20in%20an%20ancient%20palace%20corridor%2C%20rich%20dark%20navy%20and%20warm%20lantern%20orange%2C%20ornate%20atmosphere&width=600&height=900&seq=97v-cover-020&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20courtyard%20at%20night%20with%20rows%20of%20lanterns%20and%20mist%2C%20deep%20navy%20sky%20and%20warm%20orange%20glow%2C%20cinematic%20historical%20drama%20wide%20shot&width=1600&height=900&seq=97v-back-020&orientation=landscape",
    synopsis:
      "皇城每夜宵禁后，仍有一队人提着灯在宫墙之间巡行。他们记录的不是宫闱秘事，而是一桩桩被写成“意外”的命案。",
    tags: ["古装探案", "权谋", "东方美学"],
  },
  {
    id: "t-009",
    title: "海岸线以北",
    enTitle: "North of the Coastline",
    type: "tv",
    genres: ["剧情", "悬疑"],
    region: "欧美",
    year: 2025,
    rating: 9.0,
    heat: 8900,
    episodes: 8,
    duration: "55分钟/集",
    director: "奥利弗·格雷",
    cast: ["克拉拉·温特", "伊恩·麦克", "露西亚·罗"],
    updatedAt: "2025-10-09",
    status: "全8集",
    cover: "https://readdy.ai/api/search-image?query=Nordic%20mystery%20series%20poster%20with%20a%20lighthouse%20on%20a%20rocky%20cliff%20in%20stormy%20weather%2C%20cold%20grey%20blue%20sea%20and%20warm%20lamp%20in%20the%20window%2C%20moody%20minimal%20composition&width=600&height=900&seq=97v-cover-021&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Stormy%20rocky%20coastline%20with%20a%20lighthouse%20and%20crashing%20waves%2C%20overcast%20dramatic%20sky%2C%20cold%20grey%20blue%20cinematic%20nordic%20noir%20look&width=1600&height=900&seq=97v-back-021&orientation=landscape",
    synopsis:
      "一座只有六百人的北方渔镇，二十年来第一次有人失踪。返回故乡的海洋生物学家发现，镇上的每个人都记得那天，但每个人的版本都不一样。",
    tags: ["北欧悬疑", "小镇秘密", "冷色调", "迷你剧"],
  },
  {
    id: "t-010",
    title: "合租日记",
    enTitle: "Flatmate Diaries",
    type: "tv",
    genres: ["都市", "喜剧"],
    region: "大陆",
    year: 2024,
    rating: 8.0,
    heat: 7200,
    episodes: 24,
    duration: "35分钟/集",
    director: "唐柯",
    cast: ["秦小北", "娄典", "孙有才"],
    updatedAt: "2025-10-04",
    status: "全24集",
    cover: "https://readdy.ai/api/search-image?query=Friendly%20urban%20comedy%20series%20poster%20of%20four%20young%20flatmates%20crowded%20in%20a%20small%20bright%20living%20room%2C%20warm%20lamplight%20and%20plants%2C%20playful%20clean%20editorial%20style%2C%20cream%20and%20orange%20palette&width=600&height=900&seq=97v-cover-022&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Cozy%20bright%20shared%20apartment%20living%20room%20with%20plants%2C%20a%20couch%2C%20warm%20afternoon%20light%20and%20city%20view%20window%2C%20cheerful%20modern%20interior&width=1600&height=900&seq=97v-back-022&orientation=landscape",
    synopsis:
      "四个互不相识的人因为一份超低租金合租进同一间公寓，房东只提了一个要求：不许有人搬走。于是他们只能一边应付生活，一边学会和彼此的怪毛病长期共存。",
    tags: ["合租日常", "群像喜剧", "轻喜", "下饭剧"],
  },
  {
    id: "v-001",
    title: "深夜放映室",
    enTitle: "Midnight Screening Room",
    type: "variety",
    genres: ["访谈", "文化"],
    region: "大陆",
    year: 2025,
    rating: 9.2,
    heat: 9400,
    episodes: 36,
    duration: "50分钟/期",
    director: "关山",
    cast: ["主持人 老K", "常驻 顾清和", "影评人 木木"],
    updatedAt: "2025-10-17",
    status: "更新至第36期",
    cover: "https://readdy.ai/api/search-image?query=Late%20night%20talk%20show%20poster%20with%20a%20dim%20studio%20set%20of%20two%20vintage%20armchairs%20and%20a%20warm%20spotlight%2C%20deep%20navy%20backdrop%20with%20orange%20glow%2C%20elegant%20minimal%20typography&width=600&height=900&seq=97v-cover-023&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Intimate%20late-night%20talk%20show%20studio%20with%20two%20armchairs%2C%20a%20single%20warm%20spotlight%20and%20dark%20navy%20curtains%2C%20cinematic%20television%20set%20photography&width=1600&height=900&seq=97v-back-023&orientation=landscape",
    synopsis:
      "每期只请一位客人，只聊一部电影。从胶片褪色的原因聊到某场戏为什么让人哭，灯关掉之后，才是这间放映室真正开门的时间。",
    tags: ["电影访谈", "深度对谈", "影迷必看", "高评分"],
    featured: true,
  },
  {
    id: "v-002",
    title: "一起露营吧",
    enTitle: "Camp Together",
    type: "variety",
    genres: ["真人秀", "生活"],
    region: "大陆",
    year: 2024,
    rating: 8.5,
    heat: 8600,
    episodes: 24,
    duration: "75分钟/期",
    director: "宋晓",
    cast: ["嘉宾 阿木", "嘉宾 罗晓", "嘉宾 于小满"],
    updatedAt: "2025-10-16",
    status: "更新至第24期",
    cover: "https://readdy.ai/api/search-image?query=Outdoor%20camping%20reality%20show%20poster%20with%20a%20warm%20lit%20tent%20and%20campfire%20under%20stars%20beside%20a%20lake%2C%20pine%20trees%2C%20warm%20amber%20and%20deep%20navy%20night%20tones&width=600&height=900&seq=97v-cover-024&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Lakeside%20campsite%20at%20dusk%20with%20a%20glowing%20tent%20and%20campfire%2C%20mountains%20and%20stars%2C%20warm%20amber%20light%20and%20deep%20blue%20sky%2C%20cinematic%20outdoor%20photography&width=1600&height=900&seq=97v-back-024&orientation=landscape",
    synopsis:
      "六位嘉宾背着帐篷走进没有信号的野外，每期只给了三样工具。他们要做的不是挑战任务，而是学会在什么都没的时候，好好度过一个晚上。",
    tags: ["户外露营", "慢综艺", "治愈", "自然风光"],
  },
  {
    id: "v-003",
    title: "厨房狂想曲",
    enTitle: "Kitchen Rhapsody",
    type: "variety",
    genres: ["美食", "竞技"],
    region: "日韩",
    year: 2025,
    rating: 8.8,
    heat: 8800,
    episodes: 20,
    duration: "65分钟/期",
    director: "坂本悠",
    cast: ["主厨 佐藤凛", "主厨 金泰宇", "评委 和田茂"],
    updatedAt: "2025-10-15",
    status: "更新至第20期",
    cover: "https://readdy.ai/api/search-image?query=Asian%20cooking%20competition%20show%20poster%20with%20chefs%20plating%20elegant%20dishes%20in%20a%20dark%20studio%20kitchen%20lit%20by%20warm%20amber%20spotlights%2C%20steam%20and%20motion%2C%20dramatic%20food%20photography&width=600&height=900&seq=97v-cover-025&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Professional%20dark%20studio%20kitchen%20with%20chefs%20working%20under%20warm%20spotlights%2C%20steam%20and%20plated%20dishes%2C%20dramatic%20cinematic%20food%20photography&width=1600&height=900&seq=97v-back-025&orientation=landscape",
    synopsis:
      "四十位厨师，一间没有菜单的厨房。每轮评审只给一句评语，剩下的全靠锅气说话。本季新增“盲盒食材”环节，所有菜谱都要从零开始。",
    tags: ["美食竞技", "厨艺", "赛制刺激"],
  },
  {
    id: "v-004",
    title: "声音的旅行",
    enTitle: "Journey of Sound",
    type: "variety",
    genres: ["音乐", "文化"],
    region: "大陆",
    year: 2024,
    rating: 8.6,
    heat: 7100,
    episodes: 16,
    duration: "60分钟/期",
    director: "林深",
    cast: ["音乐人 陈屿", "歌手 苏禾", "制作人 老刀"],
    updatedAt: "2025-10-12",
    status: "全16期",
    cover: "https://readdy.ai/api/search-image?query=Music%20documentary%20show%20poster%20with%20a%20musician%20playing%20a%20guitar%20on%20a%20mountain%20ridge%20at%20sunset%2C%20wind%20and%20warm%20orange%20light%2C%20minimal%20elegant%20design%2C%20deep%20navy%20sky&width=600&height=900&seq=97v-cover-026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Mountain%20ridge%20at%20sunset%20with%20a%20musician%20silhouette%20and%20a%20wide%20orange%20sky%2C%20layered%20valleys%20in%20haze%2C%20cinematic%20music%20documentary%20landscape&width=1600&height=900&seq=97v-back-026&orientation=landscape",
    synopsis:
      "三位音乐人走进不同的地方，收集当地最日常的声音：菜市场的叫卖、渔船的马达、山谷里的回声。然后把这些声音，写成一首属于那里的歌。",
    tags: ["音乐旅行", "采风", "人文", "好听到哭"],
  },
  {
    id: "v-005",
    title: "周末喜剧夜",
    enTitle: "Weekend Comedy Night",
    type: "variety",
    genres: ["喜剧", "语言"],
    region: "大陆",
    year: 2025,
    rating: 8.3,
    heat: 8200,
    episodes: 30,
    duration: "80分钟/期",
    director: "王大力",
    cast: ["马三川", "范可心", "刘敢"],
    updatedAt: "2025-10-16",
    status: "更新至第30期",
    cover: "https://readdy.ai/api/search-image?query=Comedy%20stage%20show%20poster%20with%20a%20single%20microphone%20on%20a%20stand%20under%20a%20warm%20orange%20spotlight%20against%20a%20deep%20navy%20velvet%20curtain%2C%20bold%20minimal%20composition&width=600&height=900&seq=97v-cover-027&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Comedy%20club%20stage%20with%20brick%20wall%2C%20microphone%20stand%20and%20warm%20orange%20spotlight%2C%20empty%20seats%20in%20foreground%2C%20intimate%20cinematic%20atmosphere&width=1600&height=900&seq=97v-back-027&orientation=landscape",
    synopsis:
      "每期十位新人，五分钟一个段子。观众席最后一排坐着本期唯一的评审，灯亮起之前，谁都不知道会不会被喊停。",
    tags: ["脱口秀", "新人舞台", "爆笑", "现场感"],
  },
  {
    id: "v-006",
    title: "山海旅人",
    enTitle: "Travelers of the Land",
    type: "variety",
    genres: ["旅行", "纪实"],
    region: "大陆",
    year: 2023,
    rating: 8.9,
    heat: 6300,
    episodes: 12,
    duration: "45分钟/期",
    director: "周砚舟",
    cast: ["领队 阿木", "嘉宾 罗晓", "嘉宾 白昀"],
    updatedAt: "2025-09-18",
    status: "全12期",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20travel%20documentary%20poster%20with%20a%20traveler%20standing%20on%20an%20ancient%20stone%20bridge%20above%20misty%20terraced%20fields%2C%20soft%20dawn%20light%2C%20ink-wash%20inspired%20palette%20of%20deep%20navy%20and%20warm%20cream&width=600&height=900&seq=97v-cover-028&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Misty%20terraced%20rice%20fields%20in%20morning%20light%20with%20a%20small%20village%20and%20stone%20bridge%2C%20layered%20mountains%20and%20soft%20haze%2C%20cinematic%20travel%20landscape&width=1600&height=900&seq=97v-back-028&orientation=landscape",
    synopsis:
      "从海岸线到高原，从渔村到牧场，镜头跟着十二位在地生活的人，走过一年四季。不讲攻略，只讲他们怎么在这片山海之间生活。",
    tags: ["人文旅行", "纪实", "风光", "四季"],
  },
];